import request from '@/utils/request'

/**
 * FAQ 常见问题相关 API
 */

// 获取分类配置
export function getCategoryConfig(tag = '') {
  return request({
    url: '/faq/classes',
    method: 'get',
    params: {
      tag
    }
  })
}

// 获取FAQ列表
export function getFaqList(params) {
  return request({
    url: '/faq/list',
    method: 'get',
    params: {
      className: params.className || '',
      tag: params.tag || ''
    }
  })
}

// 获取FAQ详情
export function getFaqDetail(id) {
  return request({
    url: `/faq/detail/${id}`,
    method: 'get'
  })
}

// 搜索FAQ
export function searchFaq(params) {
  return request({
    url: '/faq/search',
    method: 'get',
    params
  })
}
